export const BlogCategories = [
  {name:"Cultivating Joy",slug:"cultivatingJoy",image:"/images/blog-joy.jpg"},
  {name:"Mindset",slug:"mindset",image:"/images/blog-joy.jpg"},
  {name:"Travel & Adventure",slug:"travel",image:"/images/blog-joy.jpg"},
  {name:"Personal Growth",slug:"personalGrowth",image:"/images/blog-joy.jpg"},
  {name:"Career",slug:"career",image:"/images/blog-joy.jpg"},
  {name:"Productivity",slug:"productivity",image:"/images/blog-joy.jpg"},
  {name:"Authenticity",slug:"authenticity",image:"/images/blog-joy.jpg"},
  {name:"Writing & Publishing",slug:"writing",image:"/images/blog-joy.jpg"},
  {name:"Overcoming Challenges",slug:"challenges",image:"/images/blog-joy.jpg"},
  {name:"Relationships",slug:"relationships",image:"/images/blog-joy.jpg"},
  {name:"Family Life",slug:"family",image:"/images/blog-joy.jpg"}
]
export const BlogPosts = [
  {
    title:"Life lessons for my future son",
    description:"In less than a month, I’m about to be elbow deep in poopy pampers and transform into a groggy-eyed milk machine. My world is about to be rock-a-bye babied. Scheduling weekly doctor’s appointments for NSTs and ultrasounds from here until the big day shook me awake to how little time is left. At first I started to feel overwhelmed with how much I needed to get done before then and a little sad that my pregnancy was nearing its end. And then I remembered something that has been a recurring lesson in my life–it’s the new beginnings that help us to better appreciate the journey (and it’s inevitable ending). Ready or not, life is constantly changing and moving forward so instead of fighting it, we have to jump in and enjoy the ride.",
    category:["family"],
    image:"/images/blog-joy.jpg",
    date:"April 8, 2021",
    slug:'futureson'
  },
  {
    title:"What Being Knocked Up During a Pandemic Taught Me About Presence",
    description:"Last week I kicked off my eighth month of pregnancy and as I stood sideways in front of the mirror scoping out my growing bump, I couldn’t help but trip out. Just under two months until everything changes forever. Once the baby creeps out of the depths of my lady bits, life will no longer be an individual pursuit. I will be eternally connected to another soul, one that I happened to grow in my body like a crazy Sea Monkeys experiment.",
    category:["mindset","family"],
    image:"/images/blog-joy.jpg",
    date:"March 17, 2021",
    slug:'eightmonths'
  },
  {
    title:"The Life-changing Magic of Being Openhearted",
    description:"We were sitting cross-legged in the long, narrow wooden boat, water occasionally splashing over the sides. We motored past Burmese fishermen balancing on one leg as they cast their large cone-shaped nets into the water. It was our last day on Inle Lake and for our final ride, our boat driver had his wife, Mel Soe Soe, and young son on-board as well. We didn’t speak Burmese and they didn’t speak English, so it was a quiet but surprisingly comfortable ride.",
    category:["mindset","travel","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"February 24, 2021",
    slug:'openhearted'
  },
  {
    title:"A tough-love junkie's guide to self-care: 3 steps for self-compassion",
    description:"Usually, January is my month of momentum when I take life by the tits and make progress on all of the goals that I set during December. This time it went down a little differently than usual. The first week of January I felt stuck and unmotivated. For someone who typically earns self-worth through achievement, it was a bit of a shocker (and not in the “two in the pink, one in the stink” kind of way).",
    category:["mindset","productivity"],
    image:"/images/blog-joy.jpg",
    date:"February 10, 2021",
    slug:'selfcare'
  },
  {
    title:"What 2020 Taught Me",
    description:"Every year in late December I perform a ritual of sorts. It’s not the kind where I get naked and sacrifice a goat during a full moon–it’s slightly less entertaining than that. I make a nice hot cup of coffee, put on some good music, pull out my journal, and then spend about an hour or two reflecting on the past year. I review the goals that I had set the previous January, the people I’ve met, the gifts, the challenges, and the changes in who I have become.",
    category:["mindset","challenges"],
    image:"/images/blog-joy.jpg",
    date:"December 30, 2020",
    slug:'lessons'
  },
  {
    title:"A COVID Christmas - How to master your mindset for the holidays",
    description:"The holidays are usually a festive time when the air is filled with excitement and joy. This year it feels different. It seems like the general mood is one of restlessness, discontent, and exhaustion. People are tired of living in a mediocre reproduction of Groundhog Day where the thrill of working pantsless has lost its zest.",
    category:["mindset"],
    image:"/images/blog-joy.jpg",
    date:"December 16, 2020",
    slug:'covidxmas'
  },
  {
    title:"How to Not Lose Your Shit aka The Art of Effective Communication",
    description:"Well butter my butt and call me a biscuit...We’ve officially entered the holiday season! 2020 has been a wild one and with the blur of the last several months of COVID chaos and political crap, it’s hard to believe we’re already prepping our stuffing to be smothered in gravy. This year’s festivities might be a little different than we’re used to and not just because we’ve grown accustomed to that hermit life.",
    category:["mindset","relationships"],
    image:"/images/blog-joy.jpg",
    date:"November 25, 2020",
    slug:'thanksgiving2020'
  },
  {
    title:"Nature Vibes: Why Small Actions Have Big Impacts",
    description:"I watched a documentary the other night called A Life On Our Planet. It was hosted by David Attenborough and, besides the stunning footage of the natural world, it showed how our planet is changing and the detrimental trajectory it is currently on. We silly humans are destroying the very place we call home and if we keep it up there will be no home at all.",
    category:["mindset","challenges"],
    image:"/images/blog-joy.jpg",
    date:"November 12, 2020",
    slug:'naturevibes'
  },
  {
    title:"The Badassery of Boredom",
    description:"When was the last time you were absolutely, completely, undeniably bored? Like so bored that time felt like it was dragging more than RuPaul? I bet it’s been a while. We are living in the age of distraction and most of us have forgotten what it’s like to be bored out of our minds and the hidden gift that's only revealed when we sat with our discomfort long enough.",
    category:["mindset","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"October 28, 2020",
    slug:'boredom'
  },
  {
    title:"The 3 Paths of Disappointment",
    description:"In life, we’re guaranteed to face countless disappointments and challenges. Losing a loved one, getting laid off, being diagnosed with a terminal illness, finding out your partner was bumping uglies with someone else...Bad things are inevitable. It’s simply part of the gig and as long as we’re still alive and kickin’, life will eventually drop a colossal steamy crap on our chest at the most inopportune time, sending us scrambling to recover.",
    category:["mindset","challenges"],
    image:"/images/blog-joy.jpg",
    date:"October 15, 2020",
    slug:'disappointment'
  },
  {
    title:"Excerpt from The Joys of Jet Lag: Cuba",
    description:"Roberto’s tanned, weathered hands expertly rolled the dried tobacco leaves into the quintessential Cuban cigar. Sealed with local honey, he set it aside to dry as he grabbed another one that was resting in a box on the table and began the process of cutting the cap and lighting it. He and his family ran his tobacco farm in Viñales, Cuba for decades, just recently opening it up to tours for travelers who were looking for an authentic experience from a seasoned farmer. He spoke of the changes in Cuba over the last couple of years. Life in Viñales was simple and slow-paced, in the best way possible.",
    category:["travel","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"October 1, 2020",
    slug:'cuba'
  },
  {
    title:"Stop Sabotaging Your Joy",
    description:"You ever notice how when you are really happy about something, there is a split second of terror when your imagination flashes everything you’re stoked about going to absolute shit? And then, you attempt to mellow out on your excitement as a way to protect yourself should the crazy terrible thing happen. It’s called foreboding joy, is super common, and is absolute mind-fuckery at its finest.",
    category:["mindset","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"September 9, 2020",
    slug:'foreboding'
  },
  {
    title:"Lessons from a Dog Named Donut",
    description:"A couple of weeks ago my dog turned a whopping five years old. He’s a 75-pound overly excitable furball who gets his kicks from car rides, dental chew sticks, and butt rubs. His name is Donut and over the last half-decade, he has taught me more than I can properly articulate.",
    category:["mindset","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"August 27, 2020",
    slug:'donut'
  },
  {
    title:"Stepping Outside of Anger's Fire",
    description:"The other day I realized something interesting. Stress shows up for me wearing two different masks: anger and overwhelm. It’s subtle at first, almost unnoticeable. Hints of overwhelm appear as tasks begin to stack higher on an already full plate. I brush away the thought of stress, refusing to acknowledge its presence. A mantra of “I got this, I can do it all” loops in the back of my mind with every shallow breath I take.",
    category:["mindset","challenges"],
    image:"/images/blog-joy.jpg",
    date:"August 13, 2020",
    slug:'anger'
  },
  {
    title:"Big Dreams? What Are You Waiting For?",
    description:"For as long as I can remember I wanted to live in the woods. Not in a creepy way. I wasn’t longing to grow a beard in total isolation and talk to a deflated volleyball. Rather, I felt a calling to wake up amongst towering trees and raw nature that wasn’t overly manicured and ‘perfectly’ trimmed back to the point of unrecognizable oblivion. I wanted wild.",
    category:["mindset","authenticity"],
    image:"/images/blog-joy.jpg",
    date:"July 30, 2020",
    slug:'whywait'
  },
  {
    title:"How to Transform Loneliness into Joyful Solitude",
    description:"As a kid, I wanted to be an explorer when I grew up. I’ve come to realize that traveling to a place by yourself, where you don’t know a soul, is the closest I’ve come to that sense of adventure I craved. “But...don’t you get lonely?”",
    category:["mindset"],
    image:"/images/blog-joy.jpg",
    date:"July 16, 2020",
    slug:'solitude'
  },
  {
    title:"How to Tell Failure to Suck It",
    description:"Failure and rejection. These two words have the power to make the majority of mankind’s butt pucker out of fear. Few other beliefs are capable of preventing people from achieving that which they’re capable of and keep them from even trying. Hopes and dreams are stamped out like a flaming bag of poop on your front porch. When you attempt to prevent failure by not trying, you might think that you’re protecting yourself, but in reality, you’re just getting scorched crap all over your shoes.",
    category:["challenges","mindset","personalGrowth"],
    image:"/images/blog-joy.jpg",
    date:"July 2, 2020",
    slug:'failure'
  },
  {
    title:"How to make 2020 your best year yet",
    description:"Prepare yourself. You’re about to read a sentence that’s going to feel like reality just meat slapped you and hit you with a fat load of realization. Ready for it?",
    category:["personalGrowth","career","productivity"],
    image:"/images/blog-joy.jpg",
    date:"June 18, 2020",
    slug:'halfway'
  },
  {
    title:"When Adventure Calls",
    description:"Adventure is calling. It’s been far too long since my last dose of cathartic culture shock. I crave the moments of novelty that awaken the senses and rattle me down to my core. I long for the undeniable inner knowing that tends to only come about when I travel–the reassuring gut feeling that I am exactly where I should be, doing exactly what I am meant to be doing. A feeling of trust...that for once, all is well regardless of challenges or chaos. That things are as they should be.",
    category:["mindset","cultivatingJoy","travel"],
    image:"/images/blog-joy.jpg",
    date:"June 4, 2020",
    slug:'calling'
  },
  {
    title:"A Masked Miscarriage",
    description:"Getting bad news sucks nuts. Getting crappy news while your bare ass is propped up on the crunchy paper of a doctor’s examination table, feet in stirrups and fully exposed, takes it to another level entirely.",
    category:["relationships","challenges"],
    image:"/images/blog-joy.jpg",
    date:"May 20, 2020",
    slug:'miscarriage'
  },
  {
    title:"Once Upon a Time",
    description:"This week my husband and I celebrate our 15th/3rd anniversary. To kickstart this post, let’s take a little walk down memory lane...Once upon a time, a strapping young man who was three Mike's Hard Cranberry beverages to the wind was dressed in a cow costume to introduce himself to the newbies on his college dorm floor. We'll call him, 'Jeff' because that was, in fact, his name.",
    category:["relationships"],
    image:"/images/blog-joy.jpg",
    date:"May 7, 2020",
    slug:'relationship'
  },
  {
    title:"The Hidden Lesson from Nature's Giants",
    description:"Last fall I did a solo trip to Panama and spent a little over a week in the small mountain town of Boquete. It’s a charming town known for its coffee and is home to the highly revered Geisha Coffee which can cost up to $600/pound depending on the coffee plantation that is selling it. Boquete is also known for its spectacular nature and a large network of trails that take you through the Panamanian jungle. Coffee and hiking? Right up my alley.",
    category:["travel","cultivatingjoy"],
    image:"/images/blog-joy.jpg",
    date:"April 22, 2020",
    slug:'trees'
  },
  {
    title:"Why Wearing Busy as a Badge of Honor is Total Bulls#!t",
    description:"Busy has become a modern-day dick-measuring contest. Everyone is trying to one-up each other with tales of all the crap they have going on in their lives. Who’s busier? Whose life is crazier? Who has more problems? We feel significant and important if we win. But winning the busy contest is like winning a 72 oz. steak challenge at a restaurant–you manage to smash all that meat down your face-hole in under an hour and end up feeling both proud and shitty at the same damn time.",
    category:["mindset","cultivatingjoy","productivity"],
    image:"/images/blog-joy.jpg",
    date:"April 16, 2020",
    slug:'busy'
  },
  {
    title:"What I've Learned About Becoming a Published Author",
    description:"The journey to becoming a published author has been the ultimate test of putting into practice the contents of my book, The Joys of Jet Lag: How to Find the Joy in Every Journey. It’s super easy to find joy in the journey when things are rockin’ and all is well. But when shit hits the fan and sprays you right in the face? Not so easy to keep your composure. With the latest setback, I considered changing the subtitle to How to Find the Joy in Some Journeys. It’s certainly much easier to avoid any potential hypocrisy that way.",
    category:["writing"],
    image:"/images/blog-joy.jpg",
    date:"April 9, 2020",
    slug:'publishingplatform'
  },
  {
    title:"The unexpected thing being infertile AF taught me about life",
    description:"In 2018, my husband and I decided it was time to pull the goalie and pump out some love nuggets. We ran our own business and had a plan to time the birth of our future baby so that the due date would fall just after our company’s busy season. All of our friends had gotten knocked up first try, much to the disappointment of the husbands who were hoping for more time to practice. We expected it would be just as easy.",
    category:["mindset"],
    image:"/images/blog-joy.jpg",
    date:"April 2, 2020",
    slug:'infertility'
  },
  {
    title:"How to Avoid COVID-19 Cabin Fever During Self-Quarantine",
    description:"Picture this. You are several days into your self-quarantine/WFH/shelter in place order. You’ve managed to be fairly productive working remotely and have only slipped up and had Oreos for lunch twice so far. But in light of the ever-changing developments with the coronavirus, the situation has taken a turn.",
    category:["career","productivity","mindset","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"March 20, 2020",
    slug:'covidcabinfever'
  },
  {
    title:"How to Work from Home and Not Become a Lonely Bum",
    description:"So, you just got the thumbs up to work from home from your employer because of the quickly spreading coronavirus? Congratulations on being one step closer to productively contributing to society from the comforts of your couch. #livingthedream. Be warned, though, it’s not all slippers and sweatpants. If you’re new to remote working, there are some key things you must do to make sure you don’t end up turning into a lonely, hygienically challenged sofa spud fueled by Mountain Dew.",
    category:["career","productivity"],
    image:"/images/blog-joy.jpg",
    date:"March 12, 2020",
    slug:'workfromhome'
  },
  {
    title:"Why We Need Challenges",
    description:"Last fall I was in Austria for a 10-day solo trip full of hiking and apple strudels (it’s all about balance, right?). The second to last day I was looking forward to my final hike up the Nordkette: a 5-hour hike of mostly switchbacks that ends with panoramic views of Innsbruck. A definitive butt-buster.",
    category:["personalGrowth","cultivatingJoy","travel"],
    image:"/images/blog-challenges.jpg",
    date:"March 7, 2020",
    slug:'challenges'
  },
  {
    title:"How to Use a Traveler's Mindset to Create Joy in Daily Life",
    description:"The tiny beat-up Datsun taxi sped through the narrow winding mountain roads high in the Ecuadorian Andes. The driver blasted salsa music and barely let off the gas as he passed other drivers regardless of all of the “Do Not Pass” road signs that dotted the mountainside. A quick two honks followed by tracing his hands in the sign of the cross on his body was sufficient luck to pass on the countless blind turns. Too bad I wasn’t Catholic; I had to rely solely on the hope of the honks.",
    category:["mindset","cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"February 29, 2020",
    slug:'travelersmindset'
  },
  {
    title:"How to Master Your Mindset & Accomplish Your Goals",
    description:"We all know those people–the ones who somehow are able to accomplish whatever they set their minds to, effortlessly overcoming the obstacles that would send most folks directly to the comforts of their couch in commiseration. Were those super-achievers just born with some secret sauce of unwavering determination or was it actually cultivated over time? What allows some to fail and others to succeed even against outrageous odds?",
    category:["mindset"],
    image:"/images/blog-joy.jpg",
    date:"February 20, 2020",
    slug:'mastermindset'
  },
  {
    title:"Awakening the Wild Within",
    description:"Discomfort awakens the wonder within us. When we explore beyond the outer limits of our comfort zone, we are able to once again see life with fresh eyes. Our senses absorb the differences around us, requiring us to pay attention and be present. Adventure grips hold of our spirit, shaking the long-dormant part of our authentic selves that was forced into hibernation through the monotony of our daily lives. The Wild within us stretches and opens its eyes. It calls out, having been silenced for so long.",
    category:["authenticity","mindset"],
    image:"/images/blog-joy.jpg",
    date:"February 5, 2020",
    slug:'awakeningwild'
  },
  {
    title:"5 Ways to Find Joy in F*cked Up Times",
    description:"We kicked off 2020 with a large dose of bat-shit craziness. Drone strikes and missile attacks, assassination, threats of war, and Australia is freakin’ on fire. You may have ended 2019 vowing that 2020 will be “your year”–the year you take your life to the next level, live up to your potential, and find genuine happiness. But photos of koalas with burnt paws and sad eyes have a way of deflating even the most motivated of intentions. With the state of the world in such turmoil and with the near future looking incredibly bleak, how can you find joy?",
    category:["cultivatingJoy", "personalGrowth","mindset"],
    image:"/images/blog-joy.jpg",
    date:"January 22, 2020",
    slug:'joyinchaos'
  },
  {
    title:"Facial Dingleberries: A Lesson in Receiving",
    description:"We were sitting cross-legged in the long, narrow wooden boat, water occasionally splashing over the sides. We motored past Burmese fishermen balancing on one leg as they cast their large cone-shaped nets into the water. It was our last day on Inle Lake and for our final ride, our boat driver had his wife, Mel Soe Soe, and young son on-board as well. We didn’t speak Burmese and they didn’t speak English, so it was a quiet but surprisingly comfortable ride. Through gestures and smiles, Mel Soe Soe asked if my friend, Amber, and I would like to join her family for lunch before we left. We nodded our heads in agreement and off we went for one last adventure on the lake.",
    category:["cultivatingJoy", "travel"],
    image:"/images/blog-meal.jpg",
    date:"January 9, 2020",
    slug:'myanmarmeal'
  },
  {
    title:"How to See the Gift in Problems",
    description:"With us being right in the heart of the holiday season I felt like there was no better time to write about those moments where it feels like life is giving you a festive nut-punch and Santa is dropping a hot load of coal on your chest. The holidays can be stressful and instead of bringing out our see-the-good-in-all Christmas spirit, we sometimes find ourselves teeter-tottering on an eggnog-induced outburst when something doesn’t go as planned. We each have a vision of how we think the perfect family holiday get-together should go down, and when a problem arises, we tend to get our tinsel all in a twist...",
    category:["cultivatingJoy","mindset"],
    image:"/images/blog-joy.jpg",
    date:"December 28, 2019",
    slug:'problems'
  },
  {
    title:"What's the Price of Happiness?",
    description:"It began earlier this year. Candy corn and mini Snickers shared shelf space with candy canes and logs of inedible fruitcake. The overzealous cars with red noses and clip-on window antlers made their first appearance before Thanksgiving. The Basics accessorizing their Ugg’s with Starbucks peppermint mochas are out in full effect (I get it...it’s cozy and delicious). The holidays are upon us. Holy reindeer shit, where did 2019 go? This year, like so many others, flew by and we are once again in the home stretch of December...",
    category:["cultivatingJoy"],
    image:"/images/blog-joy.jpg",
    date:"December 15, 2019",
    slug:'happiness'
  }
]



// WEBPACK FOOTER //
// ./src/utils/blog.js